'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REFRESH_WIDGET_DATA = exports.REFRESH_WIDGET_DATA = 'REFRESH_WIDGET_DATA';


//////////////////
// WEBPACK FOOTER
// ./js/widget-data/constants/actionTypes.js
// module id = 194
// module chunks = 2 3